import {
  ListAgenticLogicRuleVersionsRequestPathParamsType,
  ListAgenticLogicRuleVersionsResponseBodyType,
} from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { agenticLogicKeys } from "../queryKeys";

export const getAgenticLogicRuleVersions = async (
  pathParams: ListAgenticLogicRuleVersionsRequestPathParamsType
) => {
  const resp = await api.get<ListAgenticLogicRuleVersionsResponseBodyType>(
    `/v2/agentic-logic/rules/${pathParams.ruleId}/versions`
  );
  return resp.data;
};

export const useAgenticLogicRuleVersions = (ruleId: string | undefined) => {
  return useQuery<ListAgenticLogicRuleVersionsResponseBodyType, Error>({
    queryKey: agenticLogicKeys.versions(ruleId!),
    queryFn: async () => getAgenticLogicRuleVersions({ ruleId: ruleId! }),
    enabled: !!ruleId,
  });
};
